import { HepsiburadaOrderStatus } from './HepsiburadaOrderStatus';

export interface HepsiburadaOrder {
  hepsiburadaID: string;
  productName: string;
  quantity: number;
  status: HepsiburadaOrderStatus;
  createdAt: Date;
}

export const hepsiburadaOrderFromResponse = (
  responseData: any,
): HepsiburadaOrder => ({
  hepsiburadaID: responseData.hepsiburada_id,
  productName: responseData.product_name,
  quantity: responseData.quantity,
  status: responseData.status,
  createdAt: new Date(responseData.created_at),
});
